import { useCallback, useState } from 'react';
import { type LayoutChangeEvent } from 'react-native';

export function useIllustrationScale(baseSize: number) {
  const [scale, setScale] = useState(1);

  const handleLayout = useCallback(
    (event: LayoutChangeEvent) => {
      const width = event.nativeEvent.layout.width;

      if (!width) {
        return;
      }

      const nextScale = width / baseSize;

      setScale((currentScale) => {
        if (Math.abs(currentScale - nextScale) < 0.01) {
          return currentScale;
        }

        return nextScale;
      });
    },
    [baseSize],
  );

  const s = useCallback((value: number) => value * scale, [scale]);

  return { handleLayout, s };
}
